import {
  exceptLessThanOne,
  getCurrencyField,
  getInputLowerThanValueErrorText,
  getInputMaxValueErrorText,
  getInputMinValueErrorText,
  getTextField,
  parseIntegerNumbers,
  ValidationError,
} from '@lender/utils';
import _ from 'lodash';
import { bool, object } from 'yup';

import { MAX_NUMBER_VALUE } from 'constants/number';

const CURRENCY_FLOAT_REGEXP = /^([0-9]{1,3},?)+.?[0-9]*$/;
const EXCEPT_NUMBERS_REGEXP = /^([^0-9]*)$/;

// TODO: use it from @lender/utils when it is realized
export const getCurrencyFloatField = (
  {
    isRequired = true,
    maxValue = MAX_NUMBER_VALUE,
    lowerThanValue,
    exception = exceptLessThanOne,
    noValidate,
  } = {
    isRequired: true,
    maxValue: MAX_NUMBER_VALUE,
    lowerThanValue: undefined,
    exception: exceptLessThanOne,
  },
) => {
  if (noValidate) {
    return getCurrencyField({ isRequired: false });
  }

  return getCurrencyField({
    isRequired,
    currency: CURRENCY_FLOAT_REGEXP,
    exception,
    exceptionErrorText: getInputMinValueErrorText(1, true),
  })
    .test(
      'match',
      getInputMaxValueErrorText(maxValue, true),
      value => Number(parseIntegerNumbers(value || '')) <= maxValue,
    )
    .test('match', getInputLowerThanValueErrorText(lowerThanValue, true), value =>
      lowerThanValue ? Number(parseIntegerNumbers(value || '')) < lowerThanValue : true,
    );
};

export const getZipField = ({ isRequired = true }) => {
  const zipFieldRegexp = new RegExp(`${!isRequired ? '^$|' : ''}[0-9]{5}`);

  return getTextField({ isRequired }).matches(zipFieldRegexp, ValidationError.ZipCode).nullable();
};

export const getNonUSZipField = ({ isRequired = true }) => {
  const zipFieldRegexp = new RegExp(`${!isRequired ? '^$|' : ''}.{5,10}`);

  return getTextField({ isRequired }).matches(zipFieldRegexp, ValidationError.ZipCode).nullable();
};

export const getExceptDigitsTextField = ({ isRequired = true }) =>
  getTextField({ isRequired }).matches(EXCEPT_NUMBERS_REGEXP, ValidationError.NumbersNotAllowed);

export const getSpecificPatternTextField = ({
  isRequired = true,
  patternRegExp,
  validationMessage,
}) => {
  if (patternRegExp) {
    return getTextField({ isRequired })
      .matches(patternRegExp, { message: validationMessage, excludeEmptyString: !isRequired })
      .nullable();
  }

  return getTextField({ isRequired });
};

export const getMustBeGreaterThanZeroValidationMessage = ({ fieldName }) =>
  `${_.startCase(fieldName) ?? ''} must be greater than 0`;

export const getCheckboxGroupField = ({
  isRequired,
  isRestyled = false,
  validationMessage = ValidationError.RequiredField,
}) =>
  isRestyled
    ? object()
        .test(
          'at-least-one-true',
          validationMessage,
          obj => !isRequired || Object.values(obj).some(value => value === true),
        )
        .nullable()
    : getTextField({ isRequired, validationMessage });

export const getCheckboxField = ({
  isRequired,
  validationMessage = ValidationError.RequiredField,
}) =>
  bool()
    .test('should-be-true-if-required', validationMessage, value => !isRequired || !!value)
    .nullable();
